"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _dataparcels = _interopRequireDefault(require("dataparcels"));

var _dangerouslyUpdateParcelData = _interopRequireDefault(require("dataparcels/dangerouslyUpdateParcelData"));

var _default = function _default(prevParcel) {
  for (var _len = arguments.length, pipe = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    pipe[_key - 1] = arguments[_key];
  }

  return function (parcel) {
    var _parcel$_changeAndRet = parcel._changeAndReturn(function (parcel) {
      var _parcel$modifyDown;

      var setPrevParcel;

      if (prevParcel) {
        var prevParcelData = prevParcel.data;
        setPrevParcel = (0, _dangerouslyUpdateParcelData.default)(function () {
          return prevParcelData;
        });
      }

      return (_parcel$modifyDown = parcel.modifyDown(setPrevParcel || function (ii) {
        return ii;
      })).pipe.apply(_parcel$modifyDown, pipe)._setData(parcel.data);
    }),
        _parcel$_changeAndRet2 = (0, _slicedToArray2.default)(_parcel$_changeAndRet, 1),
        changedParcel = _parcel$_changeAndRet2[0];

    return changedParcel;
  };
};

exports.default = _default;